<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        itemDetails.title = $_(`VanityFrame${gameItem.frameId}Title`);
        itemDetails.description = $_(`VanityFrame${gameItem.frameId}Description`);
        itemDetails.amount = item.amount;
        itemDetails.icon = `vanity_frame_${gameItem.frameId}`;
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }


    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
